import { Star } from 'lucide-react';

import { cn } from '../../lib/cn';

interface StarRatingProps {
  /** 1-5, o null si todavía no se calificó. */
  value: number | null;
  onChange?: (calificacion: number) => void;
  readOnly?: boolean;
  size?: number;
  /** Template del aria-label de cada estrella con el placeholder `{n}`, ej.
   * "Calificar con {n} de 5 estrellas" (el diccionario i18n no soporta funciones). */
  label: string;
  className?: string;
}

// Control de calificación de 1 a 5 estrellas (Slice B, D-027) — botones reales
// (no divs) para que cada estrella sea accesible por teclado.
export function StarRating(p: StarRatingProps): JSX.Element {
  const size = p.size ?? 16;
  return (
    <div className={cn('flex items-center gap-0.5', p.className)} role="group">
      {[1, 2, 3, 4, 5].map((n) => {
        const llena = p.value !== null && n <= p.value;
        return (
          <button
            key={n}
            type="button"
            disabled={p.readOnly}
            onClick={() => p.onChange?.(n)}
            aria-label={p.label.replace('{n}', String(n))}
            aria-pressed={llena}
            className={cn(
              'rounded-sm text-marca-primario transition-colors',
              p.readOnly ? 'cursor-default' : 'cursor-pointer hover:text-marca-primario-oscuro',
            )}
          >
            <Star size={size} fill={llena ? 'currentColor' : 'none'} aria-hidden />
          </button>
        );
      })}
    </div>
  );
}
